import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { ADModalBody, ADModalInfo, AdvancedDragModal } from "./AdvancedDragModal";
import { MIBIcon, MIBIcons, MIBVariants, SimpleMIBIcons } from "./MIBIcon";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { ViewButtonDropdown } from "src/propertyInfoTemplates/PropertyComponents";
import { useState } from "react";

export function DemoSideIcons(props: { managedWindow: ManagedWindow }) {
   const { dispatch: windowDispatch } = useWindowContext();
   const [variant, setVariant] = useState<MIBVariants>("Linear");


   return (
      <AdvancedDragModal
         onClose={() => {
            windowDispatch(closeWindow(props.managedWindow.id));
         }}
         PosDefault={{ width: "800px", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
         title={"Demoside Ikoner"}
         subHeaderContent={<>
            <ViewButtonDropdown onSelect={(value) => {
               setVariant(value);
            }} value={variant} options={[
               { value: "Linear", text: "Linear" },
               { value: "Outline", text: "Outline" },
               { value: "Broken", text: "Broken" },
               { value: "Bold", text: "Bold" },
               { value: "Bulk", text: "Bulk" },
               { value: "TwoTone", text: "TwoTone" },
            ]} >
               Variant
            </ViewButtonDropdown>
         </>}
      >
         <ADModalInfo >
            Velkommen til MIB (Mapit's Ikon Bibliotek) her finder du ikoner og hvad de bør bruges til.
         </ADModalInfo>
         <ADModalBody>
            <h4 style={{ margin: "8px", marginTop: "12px" }}>New Icons (Iconsax)</h4>
            <div style={{ display: "grid", gridTemplateColumns: "Repeat(auto-fill, minmax(150px, 1fr))", gap: "8px", margin: "8px" }}>
               {MIBIcons.map((icon) => (
                  <div key={icon} onClick={() => {
                     navigator.clipboard.writeText(`<MIBIcon icon="${icon}" />`)
                  }} style={{ display: "flex", flexDirection: "column", alignItems: "start", boxShadow: "0 0 4px rgba(0,0,0,0.2)", padding: "5px 5px 0px", borderRadius: "4px" }}>
                     <MIBIcon icon={icon} variant={variant} style={{ fontSize: "24px" }} />
                     <span>{icon}</span>
                  </div>
               ))}
            </div>
            <h4 style={{ margin: "8px", marginTop: "12px" }}>Old Icons (Mixed)</h4>
            <div style={{ display: "grid", gridTemplateColumns: "Repeat(auto-fill, minmax(150px, 1fr))", gap: "8px", margin: "8px" }}>
               {SimpleMIBIcons.map((icon) => (
                  <div key={icon} onClick={() => {
                     navigator.clipboard.writeText(`<MIBIcon icon="${icon}" />`)
                  }} style={{ display: "flex", flexDirection: "column", alignItems: "start", boxShadow: "0 0 4px rgba(0,0,0,0.2)", padding: "5px 5px 0px", borderRadius: "4px" }}>
                     <MIBIcon icon={icon} style={{ fontSize: "24px" }} />
                     <span>{icon}</span>
                  </div>
               ))}
            </div>
         </ADModalBody>
      </AdvancedDragModal>
   )
}

